/**
 * Canonical intake status / document classification enums.
 *
 * Declared here as `const` objects so we get both the runtime values (used
 * across stores, routes, and components) AND literal-type unions for use in
 * typed code. `intake.js` re-exports these for backwards compatibility so
 * existing callers keep working.
 */
export const INTAKE_STAGE = {
    INTAKE: "INTAKE",
    QUALIFY_PATIENT: "QUALIFY_PATIENT",
    CLINICAL_REVIEW: "CLINICAL_REVIEW",
    PRIOR_AUTHORIZATION: "PRIOR_AUTHORIZATION",
    DENIAL_FOLLOWUP: "DENIAL_FOLLOWUP",
    ARCHIVED: "ARCHIVED",
};
export const INTAKE_STAGE_LABELS = {
    [INTAKE_STAGE.INTAKE]: "Inbox",
    [INTAKE_STAGE.QUALIFY_PATIENT]: "Qualify Patient",
    [INTAKE_STAGE.CLINICAL_REVIEW]: "Document Review",
    [INTAKE_STAGE.PRIOR_AUTHORIZATION]: "Prior Authorization",
    [INTAKE_STAGE.DENIAL_FOLLOWUP]: "Denial Follow-up",
    [INTAKE_STAGE.ARCHIVED]: "Archived",
};
export const DOCUMENT_STAGE = {
    PRE_PROCESSING: "PRE_PROCESSING",
    INTAKE: "INTAKE",
    ARCHIVED: "ARCHIVED",
    EHR_PROCESSING: "EHR_PROCESSING",
    SENT_TO_EHR: "SENT_TO_EHR",
    INTAKE_COMPLETE: "INTAKE_COMPLETE",
    OCR_PROCESSED: "OCR_PROCESSED",
};
export const DOCUMENT_STAGE_LABELS = {
    [DOCUMENT_STAGE.PRE_PROCESSING]: "Processing",
    [DOCUMENT_STAGE.INTAKE]: "Inbox",
    [DOCUMENT_STAGE.ARCHIVED]: "Archived",
    [DOCUMENT_STAGE.EHR_PROCESSING]: "Processing",
    [DOCUMENT_STAGE.SENT_TO_EHR]: "Sent to EHR",
    [DOCUMENT_STAGE.INTAKE_COMPLETE]: "Review Approved",
    [DOCUMENT_STAGE.OCR_PROCESSED]: "OCR Processed",
};
export const DOCUMENT_CLASSIFICATIONS = {
    INSURANCE_CARD: "INSURANCE_CARD",
    ORDER_FORM: "ORDER_FORM",
    OTHER: "OTHER",
    PAYOR_RESPONSE: "PAYOR_RESPONSE",
    APPROVAL: "APPROVAL",
    DENIAL: "DENIAL",
    TO_DO: "TO_DO",
};
